const SEARCH_FIELD_PREFIX = "SearchField";

export const SEARCH_FIELD_CLASSES = {
  inputBase: `${SEARCH_FIELD_PREFIX}-inputBase`,
  buttonMode: `${SEARCH_FIELD_PREFIX}-buttonMode`,
  icon: `${SEARCH_FIELD_PREFIX}-icon`,
  clear: `${SEARCH_FIELD_PREFIX}-clear`,
};
